<template>
  <div class="wrapper">
    <div class="tab-options">
      <div class="filter-widget">
        <div class="search-widget">
          <div class="search-group">
            <img class="search" src="@/assets/icons/search.svg" />
            <input
              @keyup="searchCandidates"
              placeholder="Search"
              type="Type in to Search"
            />
          </div>
        </div>
        <div class="filter-select-widget divider">
          <filter-select v-model="view_type" :content="display_filter"
            >Display</filter-select
          >
        </div>

        <div
          class="filter-select-widget"
          :class="{ divider: $localStorage.get('main_role') != 'team-manager' }"
        >
          <img src="@/assets/admin-icon/filter.svg" />
          <filter-select v-model="sort_filter_data" :content="sort_filter"
            >Filter</filter-select
          >
        </div>
      </div>

      <button
        class="btn-add"
        @click="addSectionNew()"
        v-if="$localStorage.get('main_role') != 'team-manager'"
      >
        <span> Add Section </span>
        <img src="@/assets/admin-icon/white-circle-plus.svg" />
      </button>
    </div>
    <vue-scroll>
      <div class="wrapper-section">
        <div
          class="column"
          :class="{ relaxed: view_type == 'relaxed' }"
          v-for="(item, index) in columns"
          :key="index"
        >
          <div class="container story_body">
            <div class="header">
              <div class="row-1">
                <div class="title" @click="editSection(item)">
                  {{ item.name | validate }}
                </div>
                <div class="options">
                  <button @click="addNewStory(item)" class="btn-add">+</button>
                </div>
              </div>
              <div class="row-2">
                <hr />
              </div>
            </div>
            <vue-scroll>
              <div
                class="body"
                @dragover.self="columnDradOver($event, index)"
                @dragenter.self="columnDradEnter($event, index)"
                @dragleave.self="columnDradLeave($event, index)"
                @drop.self="columnDradDrop($event)"
              >
                <div
                  v-for="(candidate, i) in item.candidates"
                  :key="i"
                  class="card"
                  draggable="true"
                  @dragstart="cardDradStart($event, candidate, index, i)"
                  @dragend="cardDragEnd"
                  @dragover="cardDradOver($event, index)"
                  @dragenter="cardDradEnter($event, index, i)"
                  @dragleave="cardDradLeave($event, index)"
                  @drop="cardDradDrop($event)"
                >
                  <div class="card-header">
                    <input type="checkbox" class="card-checkbox" />
                  </div>
                  <div class="title-info">
                    <img
                      v-if="candidate.photo"
                      :src="$crmFullUrl('images/profiles/' + candidate.photo)"
                    />
                    <img
                      v-else
                      class="profile-logo"
                      src="@/assets/avatar.png"
                    />
                    <span class="name" @click="viewStory(candidate)">{{
                      candidate.name | validate
                    }}</span>
                  </div>
                  <div class="phone" @click="viewStory(candidate)">
                    {{ candidate.phone | validate }}
                  </div>
                  <div class="email" @click="viewStory(candidate)">
                    {{ candidate.email | validate }}
                  </div>
                  <div class="content" @click="viewStory(candidate)">
                    {{ candidate.description | validate }}
                  </div>
                </div>
                <div
                  @dragover="cardDradOver($event, index)"
                  @dragleave="cardDradLeave($event, index)"
                  @drop="cardDradDrop($event)"
                  v-if="item.on_drag_active"
                  class="drag-holder card"
                >
                  Drag here
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
    </vue-scroll>

    <!-- Add - Update Modal -->
    <div class="overlay" v-if="show_form">
      <div class="form-widget-modal">
        <div class="moder-header">
          <h4 v-if="!form.id">Create a new Candidate</h4>
          <h4 v-else>Update Candidate</h4>
        </div>
        <div class="modal-body">
          <div class="input-group">
            <div class="input-header">
              <label>Candidate name*</label>
              <div class="option">
                <input
                  v-model="form.exist_candidate"
                  type="checkbox"
                  id="sfga"
                />
                <span for="sfga">Existing candidate</span>
              </div>
            </div>

            <input
              v-model="form.candidate_name"
              type="text"
              class="input-form"
            />
            <div
              class="candidate-search-reasult"
              v-if="form.exist_candidate && candidate_search_result.length > 0"
            >
              <div
                class="candidate-item"
                v-for="(member, index) in candidate_search_result"
                :key="index"
                @click="selectCandidate(member)"
              >
                <img
                  v-if="member.profile_picture"
                  :src="$fullUrl('images/profiles/' + member.profile_picture)"
                />
                <img v-else src="@/assets/avatar.png" />
                <span class="name">{{
                  (member.first_name + " " + member.last_name) | validate
                }}</span>
              </div>
            </div>
          </div>

          <div class="twin-input">
            <div class="input-group">
              <label>Phone</label>
              <input v-model="form.phone" type="text" class="input-form" />
            </div>

            <div class="input-group">
              <label>Email</label>
              <input v-model="form.email" type="text" class="input-form" />
            </div>
          </div>

          <div class="input-group">
            <label>Description</label>
            <textarea
              v-model="form.description"
              type="text"
              class="input-form"
            ></textarea>
          </div>
          <div class="input-group">
            <label>Candidate image</label>
            <div
              class="upload-input"
              v-if="form.profile_picture"
              style="height: 100px; width: 100px"
            >
              <Uploader
                @onFileSelected="setImagefile"
                :max_size="5"
                :value="{
                  url: $fullUrl('images/profiles/'),
                  file_name: form.file_url,
                }"
              />
            </div>
            <div
              v-else
              class="upload-input"
              style="height: 100px; width: 100px"
            >
              <Uploader
                @onFileSelected="setImagefile"
                :max_size="5"
                :value="{
                  url: $crmFullUrl('images/profiles/'),
                  file_name: form.file_url,
                }"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <c-button
            class="btn-save"
            :loading="loading_add_story"
            @click="submitStory()"
            >Save</c-button
          >
          <button class="btn-cancel" @click="show_form = false">Cancel</button>
        </div>
      </div>
    </div>

    <!-- Add - Update Modal -->
    <div class="overlay" v-if="show_section_form">
      <div class="form-widget-modal section-modal">
        <div class="moder-header">
          <h4 v-if="!section_form.id">Create a new Section</h4>
          <h4 v-else>Update Section</h4>
          <button
            class="btn-section-delete"
            v-if="section_form.id"
            @click="deleteSection(section_form.id)"
          >
            <img src="@/assets/admin-icon/trush.svg" /> Delete
          </button>
        </div>
        <div class="modal-body">
          <div class="input-group">
            <label>Section name*</label>
            <input
              v-model="section_form.section_name"
              type="text"
              class="input-form"
            />
          </div>
        </div>
        <div class="modal-footer">
          <c-button
            class="btn-save"
            :loading="section_add_loading"
            @click="submitSection()"
            >Save</c-button
          >
          <button class="btn-cancel" @click="show_section_form = false">
            Cancel
          </button>
        </div>
      </div>
    </div>

    <!-- View story-->
    <div class="overlay" v-if="show_story_form && story_item">
      <div class="form-widget-modal story-form-widget-modal">
        <div class="moder-header">
          <div class="options">
            <button class="btn-edit" @click="editStory(story_item)">
              <img src="@/assets/admin-icon/pensil.svg" /> Edit
            </button>
            <app-dialog
              title="Delete Candidate"
              ask="Are you sure you want to delete this candidate?"
              yesText="Delete"
              noText="Cancel"
              @onComfirm="deleteStory(story_item)"
            >
              <button class="btn-delete">
                <img src="@/assets/admin-icon/trush.svg" /> Delete
              </button>
            </app-dialog>
          </div>
          <button @click="show_story_form = false" class="btn-close">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <h4>{{ story_item.name | validate }}</h4>
          <h5 v-if="story_item.phone">{{ story_item.phone | validate }}</h5>
          <h6 v-if="story_item.email">{{ story_item.email | validate }}</h6>
          <p>{{ story_item.description | validate }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
  components: {},
  data: () => ({
    view_type: "relaxed",
    show_form: false,
    columns: [],
    item_hold: null,
    active_column_index: null,
    active_card_index: null,
    inactive_column_index: null,
    inactive_card_index: null,
    form: {
      id: null,
      column_id: null,
      team_id: null,
      file_url: "",
      file: null,
      file_set: true,
      exist_candidate: false,
      profile_picture: "",
      candidate_name: "",
      phone: "",
      email: "",
      description: "",
    },
    story_account: null,
    story_contact: null,
    section_form: {
      id: null,
      team_id: null,
      section_name: "",
    },
    show_section_form: false,
    section_add_loading: false,
    loading_add_story: false,
    show_story_form: false,
    story_item: null,
    display_filter: [
      {
        value: "relaxed",
        name: "Relaxed",
      },
      {
        value: "compact",
        name: "Compact",
      },
    ],
    sort_filter: [
      {
        value: "create_date",
        name: "Create Date",
      },
      {
        value: "name",
        name: "Name",
      },
    ],
    sort_filter_data: "",
    teams_filter_data: "",
    team_filter: [],
    candidate_search_result: [],
  }),
  mounted() {
    let vm = this;
    vm.getCandidates();
  },
  methods: {
    searchCandidates({ target }) {
      let vm = this;
      vm.$store
        .dispatch("CANDIDATES_SEARCH", {
          query: target.value,
          team_id: vm.form.team_id,
        })
        .then((response) => {
          vm.columns = response.data.map((item) => {
            eventBus.$set(item, "on_drag_active", false);
            return item;
          });
        })
        .catch((error) => {});
    },
    filterBySort(val) {
      let vm = this;
      vm.$store
        .dispatch("CANDIDATES_FILTER_BY_SORT", {
          option: val,
          team_id: vm.form.team_id,
        })
        .then((response) => {
          vm.columns = response.data.map((item) => {
            eventBus.$set(item, "on_drag_active", false);
            return item;
          });
        })
        .catch((error) => {});
    },
    filterByTeam(val) {
      let vm = this;
      vm.form.team_id = val;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("CANDIDATES_GET_ALL", { team_id: vm.form.team_id })
        .then((response) => {
          vm.columns = response.data.map((item) => {
            eventBus.$set(item, "on_drag_active", false);
            return item;
          });
          vm.$store.dispatch("LOADER_CLOSE");
          if (vm.$route.params.id) {
            vm.columns.forEach((column) => {
              column.candidates.forEach((candidate) => {
                if (candidate.id == vm.$route.params.id) {
                  vm.viewStory(candidate);
                }
              });
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
        });
    },
    selectCandidate(item) {
      let vm = this;
      vm.form.candidate_name = item.first_name + " " + item.last_name;
      if (item.profile) {
        vm.form.phone = item.profile.phone;
      }
      vm.form.email = item.email;
      vm.form.profile_picture = item.profile_picture;
      vm.form.file = null;
      vm.form.file_url = item.profile_picture;
      vm.form.exist_candidate = false;
    },
    getExistingCandidate(query) {
      let vm = this;
      if (vm.form.exist_candidate) {
        vm.$store
          .dispatch("SEARCH_EVERYTHING", {
            query: query,
            url: "/company/search-members",
            type: "site",
            team_id: vm.form.team_id,
          })
          .then((response) => {
            vm.candidate_search_result = response.data;
          })
          .catch((error) => {});
      }
    },
    setImagefile(file) {
      let vm = this;
      if (file) {
        vm.form.file = file;
        vm.form.file_set = true;
        vm.form.profile_picture = "";
      } else {
        vm.form.file_set = false;
      }
    },
    deleteSection(id) {
      let vm = this;
      vm.$store
        .dispatch("CANDIDATES_DELETE_SECTION", {
          column_id: id,
          team_id: vm.form.team_id,
        })
        .then((response) => {
          vm.show_section_form = false;
          vm.getCandidates();
        })
        .catch((error) => {});
    },
    editSection(item) {
      let vm = this;
      vm.section_form.id = item.id;
      vm.section_form.section_name = item.name;
      vm.show_section_form = true;
    },
    editStory(candidate) {
      let vm = this;
      vm.form.id = candidate.id;
      vm.form.column_id = candidate.column_id;
      vm.form.file_url = candidate.photo;
      vm.form.candidate_name = candidate.name;
      vm.form.phone = candidate.phone;
      vm.form.email = candidate.email;
      vm.form.profile_picture = "";
      vm.form.description = candidate.description;
      vm.show_form = true;
      vm.show_story_form = false;
    },
    viewStory(candidate) {
      let vm = this;
      vm.$router.push({
        name: "candidates",
        params: { id: candidate.id },
      });
      vm.show_story_form = true;
      vm.story_item = candidate;
    },
    deleteStory(candidate) {
      let vm = this;
      vm.$store
        .dispatch("CANDIDATES_DELETE_STORY", {
          section_id: candidate.column_id,
          candidate_id: candidate.id,
          team_id: vm.form.team_id,
        })
        .then((response) => {
          vm.show_story_form = false;
          vm.getCandidates();
        })
        .catch((error) => {});
    },
    getCandidates() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("CANDIDATES_GET_ALL", { team_id: vm.form.team_id })
        .then((response) => {
          vm.columns = response.data.map((item) => {
            eventBus.$set(item, "on_drag_active", false);
            return item;
          });
          vm.$store.dispatch("LOADER_CLOSE");
          if (vm.$route.params.id) {
            vm.columns.forEach((column) => {
              column.candidates.forEach((candidate) => {
                if (candidate.id == vm.$route.params.id) {
                  vm.viewStory(candidate);
                }
              });
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
        });
    },
    submitStory() {
      let vm = this;
      const rules = {
        candidate_name: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Candidate name can not be empty";
          },
        },
        phone: {
          run: (value) => {
            if (value.length == 0) {
              return "Phone number can not be empty";
            } else {
              if (/^\d+$/.test(value)) {
                return false;
              } else {
                return "We don't accept any character on phone number, use only number";
              }
            }
          },
        },
        email: {
          run: (value) => {
            if (value.length == 0) {
              return "Email can not be empty";
            } else {
              const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              if (re.test(String(value).toLowerCase())) {
                return false;
              }
            }
            return "Email is invalid";
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.loading_add_story = true;
        let form_data = new FormData();
        form_data.append("id", vm.form.id);
        if (vm.form.file) {
          form_data.append("file", vm.form.file, vm.form.file.name);
        }
        form_data.append("file_set", vm.form.file_set ? "1" : "0");

        form_data.append("column_id", vm.form.column_id);
        form_data.append("candidate_name", vm.form.candidate_name);
        form_data.append("phone", vm.form.phone);
        form_data.append("email", vm.form.email);
        form_data.append("description", vm.form.description);
        if (vm.form.profile_picture) {
          form_data.append(
            "profile_picture",
            vm.$fullUrl("images/profiles/") + vm.form.profile_picture
          );
        }
        if (!vm.form.id) {
          vm.$store
            .dispatch("CANDIDATES_ADD_NEW_STORY", form_data)
            .then((response) => {
              vm.loading_add_story = false;
              vm.show_form = false;
              vm.getCandidates();
              vm.form.file_set = true;
            })
            .catch((error) => {
              vm.loading_add_story = false;
            });
        } else {
          vm.$store
            .dispatch("CANDIDATES_UPDATE_STORY", form_data)
            .then((response) => {
              vm.loading_add_story = false;
              vm.show_form = false;
              vm.getCandidates();
              vm.form.file_set = true;
            })
            .catch((error) => {
              vm.loading_add_story = false;
            });
        }
      }
    },
    submitSection() {
      let vm = this;
      vm.section_add_loading = true;
      if (!vm.section_form.id) {
        vm.$store
          .dispatch("CANDIDATES_ADD_NEW_SECTION", vm.section_form)
          .then((response) => {
            vm.section_add_loading = false;
            vm.show_section_form = false;
            vm.getCandidates();
          })
          .catch((error) => {
            vm.section_add_loading = false;
          });
      } else {
        vm.$store
          .dispatch("CANDIDATES_UPDATE_SECTION", vm.section_form)
          .then((response) => {
            vm.section_add_loading = false;
            vm.show_section_form = false;
            vm.getCandidates();
          })
          .catch((error) => {
            vm.section_add_loading = false;
          });
      }
    },
    addNewStory(item) {
      let vm = this;
      vm.show_form = true;
      vm.form = {
        id: null,
        column_id: item.id,
        team_id: vm.form.team_id,
        file_url: "",
        file: null,
        candidate_name: "",
        phone: "",
        email: "",
        description: "",
      };
    },
    addSectionNew() {
      let vm = this;
      vm.show_section_form = true;
      vm.section_form = {
        id: null,
        team_id: vm.form.team_id,
        section_name: "",
      };
    },
    cardDragEnd({ target }) {
      target.className = " card";
    },
    cardDradStart(e, item, column_index, card_index) {
      let vm = this;
      vm.item_hold = item;
      vm.inactive_column_index = column_index;
      vm.inactive_card_index = card_index;
      e.target.className += " hold";
      setTimeout(() => {
        e.target.className += " invisible";
      }, 0);
    },
    columnDradOver(e, index) {
      let vm = this;
      e.preventDefault();
      vm.columns.forEach((item) => {
        item.on_drag_active = false;
      });
      vm.columns[index].on_drag_active = true;
    },
    columnDradEnter(e, index) {
      e.preventDefault();
      e.target.className += " hovered";
      let vm = this;
      vm.active_column_index = index;
    },
    columnDradLeave(e) {
      e.target.className = "body";
      let vm = this;
    },
    columnDradDrop(e) {
      let vm = this;
      e.target.className = "body";
      if (vm.active_column_index != null) {
        vm.columns[vm.active_column_index].candidates.push(vm.item_hold);
        vm.columns[vm.inactive_column_index].candidates.splice(
          vm.inactive_card_index,
          1
        );
        let card_index =
          vm.columns[vm.active_column_index].candidates.length - 1;
        vm.cardMove(card_index, vm.active_column_index);
      }
    },
    cardDradOver(e, index) {
      e.preventDefault();
      let vm = this;
      vm.columns.forEach((item) => {
        item.on_drag_active = false;
      });
      vm.columns[index].on_drag_active = true;
    },
    cardDradEnter(e, column_index, card_index) {
      e.preventDefault();
      let vm = this;
      vm.active_column_index = column_index;
      vm.active_card_index = card_index;
    },
    cardDradLeave(e) {
      let vm = this;
    },
    cardDradDrop(e) {
      let vm = this;
      if (vm.active_card_index != null) {
        vm.columns[vm.inactive_column_index].candidates.splice(
          vm.inactive_card_index,
          1
        );
        vm.columns[vm.active_column_index].candidates.splice(
          vm.active_card_index,
          0,
          vm.item_hold
        );
        vm.cardMove(vm.active_card_index, vm.active_column_index);
      }
      vm.columns.forEach((item) => {
        item.on_drag_active = false;
      });
    },
    cardMove(card_index, column_index) {
      let vm = this;
      let section_id = vm.columns[column_index].id;
      let story_id = vm.columns[column_index].candidates[card_index].id;
      vm.$store
        .dispatch("CANDIDATES_MOVE_STORY", {
          to_section_id: section_id,
          story_id: story_id,
          story_index: card_index,
        })
        .then((response) => {
          vm.show_story_form = false;
        })
        .catch((error) => {});
    },
  },
  watch: {
    sort_filter_data(val) {
      let vm = this;
      vm.filterBySort(val);
    },
    "form.candidate_name"(val) {
      let vm = this;
      vm.getExistingCandidate(val);
    },
    teams_filter_data(val) {
      let vm = this;
      vm.filterByTeam(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding-top: 6px;
  padding-bottom: 6px;
  .section-options {
    position: fixed;
    top: 109px;
    right: 0px;
    padding: 0px 20px;
    .btn-add-section {
      background: #035767;
      color: #fff;
      padding: 8px 12px;
      border-radius: 15px;
      width: 121px;
      margin-left: 14px;
    }
  }
  .wrapper-section {
    height: 100%;
    display: flex;
    align-items: flex-start;
    overflow-x: auto;
    justify-content: flex-start;
    overflow-y: hidden;
    padding-left: 6px;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }
    .column {
      width: 125px;
      margin-right: 6px;
      border-radius: 5px;
      height: 100%;
      transition: 600ms ease-in-out;
      &.relaxed {
        width: 250px;
        * {
          transition: 600ms ease-in-out;
        }
        .container {
          height: calc(100vh - 128px);
          display: flex;
          flex-direction: column;
          .header {
            width: 100%;
            background: #fff;
            padding: 0px 10px;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            .row-1 {
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 50px;
              width: 100%;
              padding: 10px 0px;

              .title {
                text-transform: capitalize;
                font-size: 14px;
                font-weight: 800;
                overflow: hidden;
                text-decoration: none;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 100%;
                margin-top: 9px;
              }
              .options {
                .btn-add {
                  background: linear-gradient(180deg, #229fa5 0%, #229ea5 100%);
                  color: #fff;
                  border-radius: 5px;
                  padding-top: 3px;
                  width: 35px;
                  height: 35px;
                  margin-left: 14px;
                  font-size: 20px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
              }
            }
            .row-2 {
              hr {
                height: 2px;
                background: #ddd;
                border: none;
              }
            }
          }
          .body {
            width: 100%;
            max-height: calc(100% - 50px);
            min-height: 100px;
            overflow-y: auto;
            padding: 10px 6px;
            -ms-overflow-style: none; /* IE and Edge */
            scrollbar-width: none; /* Firefox */
            background: #fff;
            border-bottom-right-radius: 10px;
            border-bottom-left-radius: 10px;
            &::-webkit-scrollbar {
              display: none;
            }
            .card {
              width: 100%;
              background: #f5f5f5;
              position: relative;
              padding: 15px 15px;
              cursor: pointer;
              border-radius: 5px;
              margin-bottom: 5px;
              &:hover {
                .card-header {
                  .card-checkbox {
                    display: block;
                  }
                }
              }
              .card-header {
                display: flex;
                justify-content: flex-end;
                position: absolute;
                right: 2px;
                top: 2px;
                .card-checkbox:checked {
                  display: block;
                }
                .card-checkbox {
                  display: none;
                }
              }
              .title-info {
                display: flex;
                align-items: center;
                padding-right: 20px;
                img {
                  height: 20px;
                  width: 20px;
                  border-radius: 50%;
                  margin-right: 5px;
                }
                .name {
                  font-size: 15px;
                  color: #000;
                }
              }
              .phone {
                color: #0884af;
                padding-left: 25px;
                padding-right: 20px;
                margin: 4px 0px;
              }
              .email {
                color: #0884af;
                padding-left: 25px;
                padding-right: 20px;
              }
              .content {
                margin: 4px 0px;
                padding-left: 25px;
                padding-right: 20px;
              }

              &.hold {
                border: solid#04a5a5 1px;
                border-radius: 5px;
              }
              &.invisible {
                opacity: 0.5;
              }
            }
            .drag-holder {
              height: 80px;
              width: 100%;
              border: 1px dashed rgb(75, 75, 75);
              display: flex;
              align-items: center;
              justify-content: center;
            }
            &.hovered {
              background: #f4f4f4;
            }
          }
        }
      }
      .container {
        height: calc(100vh - 128px);
        display: flex;
        flex-direction: column;
        .header {
          width: 100%;
          background: #fff;
          padding: 0px 10px;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          .row-1 {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            width: 100%;
            padding: 10px 0px;

            .title {
              text-transform: capitalize;
              font-size: 14px;
              font-weight: 800;
              overflow: hidden;
              text-decoration: none;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 100%;
              margin-top: 9px;
            }
            .options {
              .btn-add {
                background: linear-gradient(180deg, #229fa5 0%, #229ea5 100%);
                color: #fff;
                border-radius: 5px;
                padding-top: 3px;
                width: 35px;
                height: 35px;
                margin-left: 14px;
                font-size: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
          .row-2 {
            hr {
              height: 2px;
              background: #ddd;
              border: none;
            }
          }
        }
        .body {
          width: 100%;
          max-height: calc(100% - 50px);
          min-height: 100px;
          overflow-y: auto;
          padding: 10px 6px;
          -ms-overflow-style: none; /* IE and Edge */
          scrollbar-width: none; /* Firefox */
          background: #fff;
          border-bottom-right-radius: 10px;
          border-bottom-left-radius: 10px;
          &::-webkit-scrollbar {
            display: none;
          }
          .card {
            width: 100%;
            background: #f5f5f5;
            position: relative;
            padding: 15px 15px;
            cursor: pointer;
            border-radius: 5px;
            margin-bottom: 5px;
            &:hover {
              .card-header {
                .card-checkbox {
                  display: block;
                }
              }
            }
            .card-header {
              display: flex;
              justify-content: flex-end;
              position: absolute;
              right: 2px;
              top: 2px;
              .card-checkbox:checked {
                display: block;
              }
              .card-checkbox {
                display: none;
              }
            }
            .title-info {
              display: flex;
              align-items: center;
              padding-right: 20px;
              img {
                height: 20px;
                width: 20px;
                border-radius: 50%;
                margin-right: 5px;
              }
              .name {
                font-size: 14px;
                font-family: "AvenirRoman";
                font-weight: 800;
                color: #000;
                overflow: hidden;
                text-decoration: none;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 115px;
              }
            }
            .phone {
              color: #0884af;
              padding-left: 25px;
              padding-right: 20px;
              margin: 4px 0px;
            }
            .email {
              color: #0884af;
              padding-left: 25px;
              padding-right: 20px;
            }
            .content {
              margin: 4px 0px;
              padding-left: 25px;
              padding-right: 20px;
              overflow: hidden;
              text-decoration: none;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 200px;
            }

            &.hold {
              border: solid#04a5a5 1px;
              border-radius: 5px;
            }
            &.invisible {
              opacity: 0.5;
            }
          }
          .drag-holder {
            height: 80px;
            width: 100%;
            border: 1px dashed rgb(75, 75, 75);
            display: flex;
            align-items: center;
            justify-content: center;
          }
          &.hovered {
            background: #f4f4f4;
          }
        }
      }
    }
  }

  .form-widget-modal {
    width: 500px;
    position: relative;
    .input-group {
      position: relative;
      .candidate-search-reasult {
        position: absolute;
        height: 200px;
        overflow-y: auto;
        z-index: 9999;
        background: #fff;
        box-shadow: 0px 0px 10px #a8a8a8;
        width: 100%;
        top: 62px;
        .candidate-item {
          display: flex;
          align-items: center;
          margin-bottom: 5px;
          padding: 5px 10px;
          cursor: pointer;
          &:hover {
            background: rgb(241, 241, 241);
          }
          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }
      }
    }
  }
  .section-modal {
    .moder-header {
      display: flex;
      justify-content: space-between;
      .btn-section-delete {
        display: flex;
        align-items: center;
        img {
          width: 12px;
          margin-right: 3px;
          margin-top: -2px;
        }
      }
    }
  }
  .story-form-widget-modal {
    width: 500px;
    min-height: 200px;
    padding: 0px;
    .moder-header {
      display: flex;
      justify-content: space-between;
      position: relative;
      padding: 10px 10px;
      padding-bottom: 0px;
      margin-bottom: 0px;
      border-bottom: 1px solid #ddd;
      .options {
        display: flex;
        align-items: center;
        button {
          display: flex;
          align-items: center;
          margin-right: 10px;
          font-size: 15px;
          img {
            width: 15px;
            margin-right: 4px;
            margin-top: -4px;
          }
        }
      }
      .btn-close {
        font-size: 30px;
        color: #890000;
      }
    }
    .modal-body {
      padding: 0px 20px;
      padding-top: 20px;
      padding-bottom: 20px;
      h4,
      h5,
      h6,
      p {
        margin: 0px;
      }
      h4 {
        font-size: 14px;
        color: #000;
        margin-bottom: 21px;
        padding-bottom: 20px;
        border-bottom: 1px solid #ddd;
      }
      h5 {
        font-size: 17px;
        color: #707070;
        margin-bottom: 21px;
        padding-bottom: 20px;
        border-bottom: 1px solid #ddd;
      }
      h6 {
        font-size: 14px;
        color: #000;
        margin-bottom: 21px;
        padding-bottom: 20px;
        border-bottom: 1px solid #ddd;
      }
      p {
        font-size: 15px;
        font-weight: 800;
        color: #707070;
        margin-bottom: 4px;
      }
      .members {
        display: flex;
        flex-direction: column;
        margin-top: 10px;
        height: 150px;
        overflow-y: auto;
        .member {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          img {
            width: 23px;
            margin-right: 10px;
            border-radius: 50%;
          }
        }
      }
    }
  }
}
.search-account-item {
  padding: 10px 15px;
  display: block;
  cursor: pointer;
  &:hover {
    background: rgb(250, 250, 250);
  }
}
.selected-search-account-item {
  padding: 5px 12px;
  display: block;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;
  &:hover {
    background: rgb(250, 250, 250);
  }
}
.search-contact-item {
  padding: 10px 15px;
  display: block;
  cursor: pointer;
  &:hover {
    background: rgb(250, 250, 250);
  }
}
.selected-search-contact-item {
  padding: 5px 12px;
  display: block;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;
  &:hover {
    background: rgb(250, 250, 250);
  }
}
</style>
